<template>
    <button :class="['feedback','action-bt',$parent.ajaxStatus[binding]]" @click="$emit('click')" :disabled="$parent.ajaxStatus[binding]!='ready'&&$parent.ajaxStatus[binding]!=undefined||disabled">
        <span v-if="$parent.ajaxStatus[binding]=='ready'||$parent.ajaxStatus[binding]==undefined">{{ready}}</span>
        <span v-else-if="$parent.ajaxStatus[binding]=='working'">{{working}}</span>
        <span v-else-if="$parent.ajaxStatus[binding]=='success'">{{success}}</span>
        <span v-else-if="$parent.ajaxStatus[binding]=='error'">{{error}}</span>
    </button>
</template>
<style scoped lang="less">
    .action-bt {
        transition: background-color .2s;

        span {
            flex: auto;
            width: auto;
        }

        &:after {
            content: "";
            width: 0;
            height: 32px;
            align-self: stretch;
            background-color: rgba(162, 158, 51, 0);
            display: block;
            border-left: none;
            flex-shrink: 0;
        }

        &.working {
            padding: 0;

            span {
                padding: 0 10px;
            }

            &:before {
                content: "";
                box-sizing: border-box;
                display: block;
                width: 22px;
                height: 22px;
                border: 2px solid rgba(0, 0, 0, 0.1);
                border-top-color: #131313;
                border-radius: 50%;
                animation: rotate .5s linear infinite;
                position: absolute;
                right: 6px;
                top: calc(50% - 11px);
            }

            &:after {
                width: 34px;
                background-size: 20px;
                background-position: center;
                background-repeat: no-repeat;
                border-left: 1px solid #ddd;
            }
        }

        &.error {
            padding: 0;
            border-color: #d00000;
            color: #d00000;
            animation: shake .3s;

            span {
                padding: 0 10px;
            }

            &.main {
                color: white;
            }

            &:after {
                width: 34px;
                background-size: 20px;
                background-image: url(../assets/images/action/error.png);
                background-position: center;
                background-repeat: no-repeat;
                background-color: #d00000;
            }
        }

        &.success {
            border-color: #4484f3;
            padding: 0;
            color: #4484f3;

            span {
                padding: 0 10px;
            }

            &.main {
                color: white;
            }

            &:after {
                width: 34px;
                background-size: 20px;
                background-image: url(../assets/images/action/success.png);
                background-position: center;
                background-repeat: no-repeat;
                background-color: #4484f3;
            }
        }

        &.main:after {
            border-left-color: rgba(255, 255, 255, .3);
        }
    }
</style>
<script>
    export default {
        props: {
            binding: {
                default: undefined
            },
            ready: {
                default: "提交"
            },
            working: {
                default: "处理中"
            },
            success: {
                default: "成功"
            },
            error: {
                default: "失败"
            },
            disabled: {
                default: false
            }
        },
        methods: {},
        mounted() {
            this.$watch(
                function () {
                    return this.$parent.ajaxStatus[this.binding]
                },
                function (after, before) {
                    var that = this;
                    if (before == "working") {
                        setTimeout(function () {
                            that.$parent.ajaxStatus[that.binding] = "ready"
                        }, 2000);
                    }
                });
        }
    }
</script>